import { Routes } from "@Front/Config/Routes";

/**
 * Home target for the header logo when the user is authenticated.
 */
export function resolveHeaderLogoHref(isCustomerOrThirdParty: boolean): string {
	return isCustomerOrThirdParty ? Routes.pages.Folder.Select : Routes.pages.Folder.base;
}
